const FleetReports = {
  CashIn: "cashin",
  BuyFuel: "buy-fuel",
  Redemption: "redemption",
  PricingHistory: "pricing-history",
  FuelCode: "fuel-code",
  FuelCard: "fuel-card",
  FuelCardList: "fuel-card-list",
  Vehicles: "vehicle-list",
  Drivers: "driver-list",
  Payment: "payment",
  MerchantPayment: "merchant-payment",
  VIPRedemptionHistory: "vip-redemption-history",
};

const ReportType = {
  CashIn: "cashin",
  BuyFuel: "buy-fuel",
  Redemption: "redemption",
  FleetAccount: "fleet-account",
  FleetPrices: "fleet-prices",
  Settlements: "settlements",
  RedemptionItem: "redemption-item",
  PricingHistory: "pricing-history",
  FuelCode: "fuel-code",
  FuelCodes: "fuel-codes",
  Mops: "mops",
  VoucherClaim: "voucher-claim",
  NewCustomerVoucher: "new-customer-voucher",
  PriceBuildup: "price-buildup",
  PriceMovement: "price-movement",
  StationAccount: "station-account",
  CustomerList: "customer-list",
  VoucherCampaign: "voucher-campaign",
  DiscountCampaign: "discount-campaign",
  RfidTopup: "rfid-topup",
  Payment: "payment",
  KYCSubmission: "kyc-submission",
  SupplierWPP: "supplier-wpp",
  FleetCard: "fuel-card-list",
  Vehicles: "vehicle-list",
  Drivers: "driver-list",
  MerchantPayment: "merchant-payment",
  VIPRedemptionHistory: "vip-redemption-history",
};

export { FleetReports, ReportType };
